import { useState } from "react";
import { motion } from "framer-motion";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import axios from "axios";
import { trackLead } from "@/lib/metaPixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailCapture({ compact = false }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | busy | done | error
  const [errorMsg, setErrorMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (status === "busy" || status === "done") return;
    setStatus("busy");
    setErrorMsg("");
    try {
      const r = await axios.post(`${API}/newsletter`, { email });
      if (r.data?.success) {
        trackLead({ email, content_name: "Sold Out Waitlist", content_category: "waitlist" });
        setStatus("done");
      } else {
        setStatus("error");
        setErrorMsg("Провери имейл адреса и опитай пак.");
      }
    } catch {
      setStatus("error");
      setErrorMsg("Нещо се обърка. Опитай отново след малко.");
    }
  };

  if (status === "done") {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        data-testid="email-capture-success"
        className="inline-flex items-center gap-3 border border-[#E0B95C]/60 bg-[#E0B95C]/10 px-6 py-4 rounded-full"
      >
        <CheckCircle2 className="w-5 h-5 text-[#E0B95C] shrink-0" strokeWidth={2.2} />
        <span className="font-display uppercase tracking-wide text-base sm:text-lg text-[#E0B95C]">
          Записан си! Ще научиш пръв какво обявяваме на 25.10.
        </span>
      </motion.div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="email-capture-form"
      className={`flex w-full ${compact ? "max-w-md" : "max-w-xl"} flex-col sm:flex-row gap-3`}
    >
      <div className="relative flex-1">
        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4.5 h-4.5 w-5 h-5 text-[#F5EBD9]/50 pointer-events-none" strokeWidth={2} />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="твоят@имейл.com"
          data-testid="email-capture-input"
          className="w-full pl-12 pr-4 py-4 rounded-full bg-[#0F2647]/80 border border-[#F5EBD9]/25 text-[#F5EBD9] placeholder:text-[#F5EBD9]/40 text-base focus:outline-none focus:border-[#E0B95C] transition-colors"
        />
      </div>
      <button
        type="submit"
        disabled={status === "busy"}
        data-testid="email-capture-submit"
        className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full uppercase tracking-widest text-sm font-bold bg-[#F5892E] text-[#0B1F3D] hover:bg-[#F5EBD9] transition-colors shadow-[0_15px_40px_-10px_rgba(245,137,46,0.7)] disabled:opacity-60"
      >
        {status === "busy" ? "Записвам..." : "Запиши ме"}
        <ArrowRight className="w-4 h-4" strokeWidth={2.8} />
      </button>
      {status === "error" && (
        <div data-testid="email-capture-error" className="w-full text-sm text-[#E5484D] sm:pl-2">
          {errorMsg}
        </div>
      )}
    </form>
  );
}
